import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconCaretLeftDouble16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconCaretLeftDouble16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M8.354 2.855a.5.5 0 0 0-.707-.708l-5.5 5.5-.354.354.354.354 5.5 5.5a.5.5 0 1 0 .707-.707L3.207 8zm5.5 0a.5.5 0 0 0-.708-.707l-5.5 5.5L7.293 8l.353.354 5.5 5.5a.5.5 0 0 0 .707-.707L8.708 8z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconCaretLeftDouble16);
